import React, { useState } from 'react';
import './BugReport.scss';

const BugReportIFrame = () => {
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div onClick={togglePopup} className="open-popup-button">Report a Bug</div>

      {isOpen && (
        <div className="popup-overlay" onClick={togglePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button-popup" onClick={togglePopup}>
              &times;
            </button>
            <iframe
              className="popup-iframe"
              src="https://forms.clickup.com/45032932/f/1ay9f4-16793/JEH8KFRYVY8E9XE6CE"
              title="Popup Content"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default BugReportIFrame;
// Bug report button...